import { TinySliderInstance, tns } from 'tiny-slider/src/tiny-slider';

export default class Articles {
    static init(): void {
        this.FilterSliderInit();
        this.FilterSliderMobileTrigger();
    }

    static FilterSliderInit(): void {
        type FilterButton = HTMLButtonElement;

        let selectedCategories: string[] = [];
        let selectedBrands: string[] = [];

        const categoryFilters: NodeListOf<FilterButton> = document.querySelectorAll('#category-filters button');
        const brandFilters: NodeListOf<FilterButton> = document.querySelectorAll('#brand-filters button');
        const clonedItems: NodeListOf<Node> | null = document.querySelector('.offers-slider__container')?.cloneNode(true)?.childNodes ?? null;
        if (!clonedItems) return;

        let slider = this.initSlider();

        const updateAndApplyFilter = (): void => {
            slider?.destroy();

            const filtered = Array.from(clonedItems)
                .filter((item: Node): item is HTMLElement => item instanceof HTMLElement)
                .filter((item: HTMLElement) => {
                    const { brand, category } = item.dataset;

                    const brandMatch = selectedBrands.length === 0 
                        || selectedBrands.includes('all') 
                        || selectedBrands.includes(brand ?? '');
                
                    const categoryMatch = selectedCategories.length === 0 
                        || selectedCategories.includes('all') 
                        || selectedCategories.includes(category ?? '');
                
                    return brandMatch && categoryMatch;
                })
                .map(item => item.cloneNode(true));

            const itemsParent: HTMLElement | null = document.querySelector('.offers-slider__container');
            if (itemsParent) {
                itemsParent.innerHTML = "";
                itemsParent.append(...filtered);
            }
            slider = this.initSlider();
        };

        const updateActiveClass = (filterGroup: NodeListOf<FilterButton>, activeFilters: string[]): void => {
            filterGroup.forEach((filter) => {
                if (activeFilters.includes(filter.dataset.category ?? filter.dataset.brand ?? '')) {
                    filter.classList.add('is-active');
                } else {
                    filter.classList.remove('is-active');
                }
            });
        };

        const filterBrandsByCategory = (): void => {
            // Sbíráme všechny brandIds z vybraných kategorií
            const allSelectedBrandIds = selectedCategories.flatMap(category => {
                const filterButton = Array.from(categoryFilters).find(filter => filter.dataset.category === category);
                return filterButton?.dataset.brandIds?.split(',') ?? [];
            });

            // Pokud není žádná kategorie vybraná nebo je vybraná "all", zobrazíme všechny značky
            if (selectedCategories.includes('all') || allSelectedBrandIds.length === 0) {
                brandFilters.forEach((filter: FilterButton) => {
                    filter.style.display = 'inline-block'; // Zobrazí všechny značky
                });
            } else {
                brandFilters.forEach((filter: FilterButton) => {
                    const brandId = filter.dataset.brandId ?? '';
                    if (brandId && allSelectedBrandIds.includes(brandId)) {
                        filter.style.display = 'inline-block';  // Zobrazí značky, které odpovídají alespoň jedné vybrané kategorii
                    } else {
                        filter.style.display = 'none';  // Schová značky, které neodpovídají žádné vybrané kategorii
                    }
                });
            }
        };

        const checkAndActivateAllCategory = (): void => {
            // Pokud není žádná kategorie aktivní, automaticky aktivuje 'all'
            if (selectedCategories.length === 0) {
                const allCategoryButton = Array.from(categoryFilters).find(filter => filter.dataset.category === 'all');
                if (allCategoryButton) {
                    selectedCategories = ['all'];
                    updateActiveClass(categoryFilters, selectedCategories);
                    filterBrandsByCategory(); // Zobrazí všechny značky
                    updateAndApplyFilter();
                }
            }
        };

        categoryFilters.forEach((filter: FilterButton) => {
            filter.addEventListener('click', function() {
                const category = this.dataset.category ?? 'all';

                if (category === 'all') {
                    selectedCategories = ['all'];
                } else {
                    if (selectedCategories.includes(category)) {
                        selectedCategories = selectedCategories.filter(cat => cat !== category);
                    } else {
                        selectedCategories = selectedCategories.filter(cat => cat !== 'all');
                        selectedCategories.push(category);
                    }
                }

                updateActiveClass(categoryFilters, selectedCategories);
                filterBrandsByCategory(); // Aktualizuje zobrazené značky podle vybraných kategorií
                updateAndApplyFilter();
                checkAndActivateAllCategory(); // Zkontroluje a aktivuje 'all', pokud je třeba
            });
        });

        brandFilters.forEach((filter: FilterButton) => {
            filter.addEventListener('click', function() {
                const brand = this.dataset.brand ?? 'all';
                if (brand === 'all') {
                    selectedBrands = ['all'];
                } else {
                    if (selectedBrands.includes(brand)) {
                        selectedBrands = selectedBrands.filter(b => b !== brand);
                    } else {
                        selectedBrands = selectedBrands.filter(b => b !== 'all');
                        selectedBrands.push(brand);
                    }
                }
                updateActiveClass(brandFilters, selectedBrands);
                updateAndApplyFilter();
            });
        });
    }

    static initSlider(): TinySliderInstance {
        return tns({
            container: '.js-filter-slider',
            items: 1,
            controlsContainer: '.js-filter-slider__controls',
            nav: false,
            loop: false,
            mouseDrag: true,
            preventScrollOnTouch: 'auto',
            swipeAngle: 30,
            navPosition: 'bottom',
            gutter: 10,

            responsive: {
                768: {
                    items: 2,
                },  
                1025: {
                    items: 3,
                    nav: true
                }
            },
        });
    }

    static FilterSliderMobileTrigger(): void {
        const filters = document.querySelectorAll('.filter');

        if (filters.length > 0) {
            const maxResolution = 767;

            const handleClick = (event: Event) => {
                const target = event.target as HTMLElement;
                
                const filterItem = target.closest('.filter');
                
                if (filterItem) {
                    const filterContentRight = filterItem.querySelector('.filter__content-right');
                    
                    if (filterContentRight) {
                        filterContentRight.classList.toggle('is-active');
                        target.classList.toggle('is-active');
                    }
                }
            };

            const addClickListeners = () => {
                const items = document.querySelectorAll('.filter');
                
                items.forEach(item => {
                    const trigger = item.querySelector('.js-mobile-trigger');
                    
                    if (trigger) {
                        trigger.addEventListener('click', handleClick);
                    }
                });
            };

            const checkWindowSize = () => {
                if (window.innerWidth <= maxResolution) {
                    addClickListeners();
                }
            };

            window.addEventListener('resize', checkWindowSize);

            checkWindowSize();
        }
    }
}
